import React, { useEffect, useRef, useState } from 'react';

import { ReactComponent as Wallet } from '../../../assets/svg/icons/wallet-04.svg';
import { ReactComponent as Collapse } from '../../../assets/svg/collapse.svg';
import { ReactComponent as EthCurrency } from '../../../assets/svg/icons/currency-ethereum.svg';
import { ReactComponent as Eth } from '../../../assets/svg/icons/eth.svg';
import classnames from 'classnames';
import CopyToClipboard from 'react-copy-to-clipboard';
import { ISKHorizontalCardProps } from '../HorizontalCard';
import { A11y, EffectCards, Keyboard, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import 'swiper/swiper-bundle.min.css';
import 'swiper/modules/effect-cards/effect-cards.min.css';
import 'swiper/modules/navigation/navigation.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import NoNFTImage from '../../../assets/fallback-image.png';
import { IconComp } from '../IconComponent';
import { BadgeSizes, SKBadge } from '../../SwapKiwi/Badge';
import { truncateAddress } from '../../../utils/truncateAddress';
import { useBreakpoint } from '../../../hooks/useBreakpoint';
export const SKHorizontalCardVariant1: React.FC<ISKHorizontalCardProps & { className?: string }> = ({
  NFTs,
  addedEther,
  walletAddress,
  onClickOnCard,
  onClickRemoveActiveState,
  isActive,
  isExpanded,
  className,
  activeNFTIndex,
  notExpandable,
}) => {
  const maxNumberOfNFTsToDisplay = isExpanded ? 3 : 4;
  const isBiggerThanMobile = useBreakpoint('48em');
  const positionCorrectorMapper = new Map();
  positionCorrectorMapper.set(1, 0);
  positionCorrectorMapper.set(2, 21);
  positionCorrectorMapper.set(3, 12);
  positionCorrectorMapper.set(4, 9);
  const NFTsLength = (NFTs && NFTs.length) ?? 0;
  const initialAmountOfNFTs = 0;
  const totalNFTs = NFTs.reduce((previousValue, currentValue) => {
    const current = currentValue.amount && parseInt(currentValue.amount) > 0 ? parseInt(currentValue.amount) : 1;
    return previousValue + current;
  }, initialAmountOfNFTs);

  const NFTWidth = '12.5rem';
  const positionCorrector =
    NFTsLength > maxNumberOfNFTsToDisplay - 1
      ? positionCorrectorMapper.get(maxNumberOfNFTsToDisplay)
      : positionCorrectorMapper.get(NFTsLength);
  const lastNFTPosition =
    positionCorrector * (NFTsLength <= maxNumberOfNFTsToDisplay ? NFTsLength - 1 : maxNumberOfNFTsToDisplay - 1);
  const NFTInfoPosition = `calc(${lastNFTPosition}% + ${NFTWidth})`;
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const currentActiveIndex = useRef(activeNFTIndex);
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  const [swiper, setSwiper] = useState<any>(null);

  useEffect(() => {
    if (isActive && swiper !== null) {
      swiper.slideTo(activeNFTIndex, 100);
    }
    if (isActive && swiper !== null && currentActiveIndex.current !== activeIndex) {
      swiper.slideTo(activeIndex, 100);
    }
    currentActiveIndex.current = activeIndex;
  }, [activeIndex, activeNFTIndex, isActive, swiper]);
  return (
    <div
      className={classnames(
        'relative flex bg-white items-end h-full rounded-xl border border-cloud-900 transition-height transition-width duration-300 ease-in-out',
        { 'bg-bkg-light-20 flex-wrap': isActive },
        { 'flex-col': !isActive },
        className,
      )}
    >
      <div className="flex items-center p-1 w-full rounded-t-xl relative self-start">
        <div
          className={classnames(
            'relative w-full transition-height transition-width duration-300 ease-in-out',
            { 'h-25': isActive },
            { 'h-25': !isActive && isExpanded },
            { 'h-7.5': !isActive && !isExpanded },
          )}
        >
          {!isActive ? (
            <>
              {NFTsLength &&
                NFTs.map((NFT, index) => {
                  return (
                    index < maxNumberOfNFTsToDisplay &&
                    NFTsLength > 0 && (
                      <div className="nft-wrapper" key={`nft-${NFT.id}-${index}`}>
                        <div
                          onClick={(): void => {
                            if (!notExpandable) {
                              onClickOnCard(index);
                            }
                          }}
                          style={
                            !isExpanded
                              ? {
                                  left: `${index * positionCorrector}%`,
                                }
                              : {
                                  left: index === 0 || (index > 0 && index % 2 === 1) ? 0 : '52%',
                                  top: index > 0 ? '55%' : 0,
                                  width: index > 1 ? '48%' : '100%',
                                  height: index > 1 ? '24%' : '50%',
                                }
                          }
                          className={classnames('nft-wrapper__image absolute top-0', 'w-7.5 h-full', {
                            'cursor-pointer': notExpandable === undefined || notExpandable === false,
                          })}
                        >
                          <img
                            className="object-cover w-full h-full rounded-xl overflow-hidden border border-cloud-900"
                            src={NFT.imgUrl ? NFT.imgUrl : NoNFTImage}
                            onError={({ currentTarget }): void => {
                              currentTarget.onerror = null;
                              currentTarget.src = NoNFTImage;
                            }}
                            alt={NFT.name}
                          />
                        </div>
                        {!isExpanded && (
                          <div
                            style={{
                              left: `calc(${NFTInfoPosition} - 65px)`,
                              width: `calc(100% - ${NFTInfoPosition} + 65px)`,
                            }}
                            className={classnames(
                              'nft-wrapper__info absolute top-0 nft-info h-full pt-1 flex flex-col text-left',
                              { 'block z-0': index === 0 },
                              { 'hidden z-10 bg-white': index !== 0 },
                            )}
                          >
                            <span className="text-lg xs-only:text-base xs-only:mb-0.2 xs-only:h-1.0625 text-cloud-900 line-clamp-1">
                              {NFT.name}
                            </span>
                            <span className="text-md xs-only:text-sm line-clamp-1 text-cloud-400">
                              {NFT.description}
                            </span>
                          </div>
                        )}
                      </div>
                    )
                  );
                })}
            </>
          ) : (
            <>
              {NFTsLength && NFTsLength > 1 && (
                <>
                  <Swiper
                    className="nft-swiper-container sm-and-below:mt-8 relative sm-and-below:w-10.5 sm-and-below:h-10.5 md:h-17.5 md:w-17.5"
                    effect={'cards'}
                    grabCursor={true}
                    keyboard={{
                      enabled: true,
                      onlyInViewport: false,
                    }}
                    modules={[A11y, Keyboard, EffectCards, Navigation, Pagination]}
                    navigation
                    pagination={{ dynamicBullets: true, clickable: true }}
                    onSlideChange={(s): void => setActiveIndex(s.activeIndex)}
                    onSwiper={(s): void => {
                      setSwiper(s);
                    }}
                  >
                    {NFTs.map((NFT, index) => {
                      return (
                        <SwiperSlide key={`slide-${NFT.id}-${index}`}>
                          <div className="border border-cloud-900 sm-and-below:w-10.5 sm-and-below:h-10.5 md:h-17.5 md:w-17.5 overflow-hidden rounded-lg bg-white">
                            <img
                              className="object-cover w-full h-full rounded-lg"
                              src={NFT.imgUrl ? NFT.imgUrl : NoNFTImage}
                              alt={NFT.name}
                              onError={({ currentTarget }): void => {
                                currentTarget.onerror = null;
                                currentTarget.src = NoNFTImage;
                              }}
                            />
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                  <div className="absolute bottom-0 left-0 right-0 h-4.5 w-full flex gap-1 content-center items-center overflow-x-auto">
                    {NFTs.map((NFT, index) => {
                      return (
                        <div
                          key={`thumbnail-${index}`}
                          className={classnames('min-w-4 max-w-4 h-4 rounded-xl overflow-hidden cursor-pointer', {
                            'border-2 border-cloud-900': activeIndex === index,
                            'border border-cloud-900': activeIndex !== index,
                            'ml-auto': index === 0,
                            'mr-auto': index === NFTs.length - 1,
                          })}
                          onClick={(): void => setActiveIndex(index)}
                        >
                          <img
                            className="object-cover w-full h-full"
                            src={NFT.imgUrl ? NFT.imgUrl : NoNFTImage}
                            alt={NFT.name}
                            onError={({ currentTarget }): void => {
                              currentTarget.onerror = null;
                              currentTarget.src = NoNFTImage;
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
              {NFTsLength && NFTsLength == 1 && (
                <div className="w-17.5 h-17.5 mx-auto my-8">
                  <img
                    className="object-cover w-full h-full rounded-xxl overflow-hidden"
                    src={NFTs[0].imgUrl ? NFTs[0].imgUrl : NoNFTImage}
                    alt={NFTs[0].name}
                    onError={({ currentTarget }): void => {
                      currentTarget.onerror = null;
                      currentTarget.src = NoNFTImage;
                    }}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {isActive && isExpanded && (
        <>
          <div className="border-t border-b border-cloud-900 w-full flex justify-between items-center min-h-2.75 px-2">
            <p className="text-sm font-bold text-cloud-900">
              {parseInt(NFTs[activeIndex].amount) > 0 ? 'ERC 1155' : 'ERC 721'}
            </p>
            {parseInt(NFTs[activeIndex].amount) > 0 && (
              <SKBadge color="black" size={BadgeSizes.MD}>
                <span>{NFTs[activeIndex].amount}</span>
              </SKBadge>
            )}
          </div>
          <div className="flex flex-col w-full p-2.5 bg-bkg-white min-h-9.5">
            <div className="nft-info flex flex-col text-left">
              <span className="text-lg text-cloud-900 line-clamp-1">{NFTs[activeIndex].name}</span>
              {/* <span className="text-tiny-bold line-clamp-2">{NFTs[activeIndex].tokenId}</span> */}
              <span className="text-base text-cloud-400 md:line-clamp-3 line-clamp-4 leading-6 mt-0.5">
                {NFTs[activeIndex].description}
              </span>
            </div>
          </div>
        </>
      )}
      <div className="w-full overflow-hidden flex flex-wrap sm:justify-between content-center items-center">
        <div className="border-t border-b border-r border-cloud-900 text-tiny items-center p-1 flex w-1/2 text-default bg-bkg-light-20">
          {isBiggerThanMobile && <IconComp className="stroke-current text-cloud-900" size={24} icon={EthCurrency} />}
          <span className="text-base xs-only:text-sm ml-1.25 xs-only:ml-0 text-cloud-900">ETH added</span>
          <SKBadge
            className="ml-auto min-w-4.5 py-1.5 gap-x-0.125"
            color="outline"
            size={isBiggerThanMobile ? BadgeSizes.LG : BadgeSizes.MD}
            iconRight={Eth}
            iconSize={20}
          >
            <span>{addedEther}</span>
          </SKBadge>
        </div>
        <div className="border-t border-b border-cloud-900 text-tiny items-center p-1.25 xs-only:p-1.125 flex w-1/2 text-default bg-bkg-light-20">
          <span className="text-base xs-only:text-sm ml-1.25 xs-only:ml-0 text-cloud-900">Total NFTs</span>
          <SKBadge
            className="ml-auto min-w-4.5 py-1.5 gap-x-0.125"
            color="outline"
            size={isBiggerThanMobile ? BadgeSizes.LG : BadgeSizes.MD}
          >
            <span>{totalNFTs}</span>
          </SKBadge>
        </div>
        <div className="text-tiny items-center px-1 py-1 xs-only:py-1.5 flex w-full bg-bkg-neutral-light">
          <IconComp icon={Wallet} size={24} />
          {walletAddress && (
            <CopyToClipboard text={walletAddress}>
              <span className="cursor-pointer hover:text-cloud-700 ml-1 text-base xs-only:text-sm truncate max-w-full">
                {truncateAddress(walletAddress)}
              </span>
            </CopyToClipboard>
          )}
        </div>
      </div>
      {isActive && (
        <button
          onClick={onClickRemoveActiveState}
          className="absolute top-1 right-1 w-2 h-2 bg-bkg-cta rounded-full flex justify-center content-center items-center"
        >
          <IconComp icon={Collapse} color="black" size={16} />
        </button>
      )}
    </div>
  );
};
